import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AppLayout from "../components/AppLayout.vue";
import LoginLayout from "../components/LoginLayout.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: { name: "connect" },
  },
  {
    path: "/",
    name: "Home",
    component: LoginLayout,
    redirect: { path: process.env.BASE_URL },
    children: [
      {
        name: "connect",
        path: "connect",
        component: () =>
          import(/* webpackChunkName: "connect" */ "../views/Connect.vue"),
        props: true,
      },
      {
        path: "",
        redirect: { name: "connect" },
      },
    ],
  },
  {
    path: "/session",
    name: "session",
    redirect: { path: "connect" },
    component: AppLayout,
    props: true,
    children: [
      {
        name: "capture",
        path: "capture",
        component: () =>
          import(
            /* webpackChunkName: "capture" */ "../components/session/Capture.vue"
          ),
        props: true,
      },
      {
        name: "config",
        path: "config",
        component: () =>
          import(
            /* webpackChunkName: "config" */ "../components/session/Config.vue"
          ),
        props: true,
      },
      {
        name: "details",
        path: "details",
        component: () =>
          import(
            /* webpackChunkName: "capture" */ "../components/session/Details.vue"
          ),
        props: true,
      },
      {
        name: "dash",
        path: "dash",
        component: () =>
          import(
            /* webpackChunkName: "capture" */ "../components/session/Dash.vue"
          ),
        props: true,
      },
    ],
  },
  {
    path: "/unsupported",
    name: "unsupported",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Unsupported.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
